import React from 'react';
import { withStyles } from '@material-ui/styles';
import clsx from 'clsx';

var styles = function styles(theme) {
  return {
    GradientWrapper: {
      background: "linear-gradient(180deg, ".concat(theme.palette.tertiary.light, " 0%, ").concat(theme.palette.tertiary.main, " 100%)"),
      display: 'flex',
      height: 'auto',
      width: '100%'
    }
  };
};
/**
 * Gradient Container with a tertiary background
 * Wraps whatever elements in a gradient background with equal ammounts of padding top + bottom
 * @param {Object} props
 * @param {Node} props.children :: Contents that will be wrapped
 * @param {Object} props.classes :: list of classes
 * @param {String} props.variant :: light or dark
 */


export var GradientContainer = withStyles(styles, {
  name: 'gradientContainer'
})(function (_ref) {
  var children = _ref.children,
      className = _ref.className,
      classes = _ref.classes;
  return /*#__PURE__*/React.createElement("div", {
    className: clsx(classes.GradientWrapper, className)
  }, children);
});